<template>
  <div class="bg-white main-wrap">
    <!-- class="bg-grey-lightest" -->
    <div class="main-page">
      <header class="flex flex-row fixed">
        <div class="header-main">
          <div class="header-logo flex-1">
            <div class="aside-btn" @click="asideClick">
              <!--              <i class="material-icons align-middle">menu</i>-->
              <svg
                width="24"
                height="16"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.23833 16.4H17.0126C17.5548 16.4 17.9985 15.8075 17.9985 15.0833C17.9985 14.3592 17.5548 13.7667 17.0126 13.7667H1.23833C0.696092 13.7667 0.252441 14.3592 0.252441 15.0833C0.252441 15.8075 0.696092 16.4 1.23833 16.4ZM1.23833 9.81667H17.0126C17.5548 9.81667 17.9985 9.22417 17.9985 8.50001C17.9985 7.77584 17.5548 7.18334 17.0126 7.18334H1.23833C0.696092 7.18334 0.252441 7.77584 0.252441 8.50001C0.252441 9.22417 0.696092 9.81667 1.23833 9.81667ZM0.252441 1.91667C0.252441 2.64084 0.696092 3.23334 1.23833 3.23334H17.0126C17.5548 3.23334 17.9985 2.64084 17.9985 1.91667C17.9985 1.19251 17.5548 0.600006 17.0126 0.600006H1.23833C0.696092 0.600006 0.252441 1.19251 0.252441 1.91667Z"
                  fill="#969696"
                />
              </svg>
            </div>
            <span v-if="!$t('website.title_image')">{{
              $t("website.title")
            }}</span>
            <!--            <img-->
            <!--                v-if="$t('website.title_image')"-->
            <!--                :src="$t('website.title_image')"-->
            <!--            />-->
            <svg
              class="logo"
              viewBox="0 0 126 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect width="126" height="32" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlink:href="#image0"
                    transform="translate(0 -0.08275) scale(0.002 0.007875)"
                  />
                </pattern>
                <image
                  id="image0"
                  width="500"
                  height="148"
                  xlink:href="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </div>
          <div class="header-menu">
            <div class="header-help">
              <a href="javascript:void(0);">
                <i class="material-icons align-middle">help</i>
              </a>
            </div>
            <div class="drop-down" v-if="user">
              <a
                href="javascript:void(0);"
                class="drop-button avatar"
                ref="dropbutton"
                @click="toggleMenu"
              >
                <span v-if="!user.photoURL">{{
                  (user.displayName ? user.displayName : user.email)
                    | getFirstLetter
                }}</span>
                <img v-else :src="user.photoURL" alt />
              </a>
              <a
                href="javascript:void(0);"
                class="drop-button drop-down-arrow"
                ref="dropbuttonarrow"
                @click="toggleMenu"
              >
                <i class="material-icons align-middle">arrow_drop_down</i>
              </a>
              <div class="drop-menu" ref="dropmenu" v-show="dropMenu">
                <div class="flex person-wrap">
                  <div class="face-content flex items-center justify-center">
                    <div class="face-container">
                      <span v-if="!user.photoURL">{{
                        (user.displayName ? user.displayName : user.email)
                          | getFirstLetter
                      }}</span>
                      <img v-else :src="user.photoURL" alt />
                      <div class="avatar-change-btn" @click="openAvatarCrop">
                        <i class="material-icons align-middle">photo_camera</i>
                      </div>
                    </div>
                  </div>
                  <div class="flex-1 info-wrap items-center justify-center">
                    <h3>
                      {{
                        (user.displayName ? user.displayName : user.email)
                          | getNameByEmail
                      }}
                    </h3>
                    <p>{{ user.email }}</p>
                    <p>
                      <a href="javarscript:void(0);">Privacy</a>
                    </p>
                    <p style="width: 195px">
                      <button class="default" @click="goSettings">
                        Setting
                      </button>
                      <button class="primary" @click="logout">Sign out</button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <transition name="edit-pannel">
          <div class="edit-pannel" v-if="editOpen">
            <div class="fixed">
              <h1>
                {{ title
                }}<span class="header-pannelclose" @click="closeEditPannelTitle"
                  ><i class="material-icons-round align-middle">close</i></span
                >
              </h1>
            </div>
          </div>
        </transition>
      </header>
      <div class="main-content head-fix-pt flex flex-row">
        <transition name="aside">
          <aside v-if="sidebarOpened == 0">
            <div class="aside-content" v-if="user && user.roles">
              <div
                class="
                  aside-personal-container
                  flex
                  items-center
                  justify-center
                  m-b-l
                "
                style="
                  border: 2px solid #0085ff;
                  box-shadow: 0px 1px 8px rgb(0 0 0 / 10%),
                    0px 3px 3px rgb(0 0 0 / 6%), 0px 3px 4px rgb(0 0 0 / 8%);
                "
                v-if="viewingAs"
              >
                <div class="flex-1 aside-personal-info p-0">
                  <div class="flex-1 flex justify-between">
                    <div class="flex-1 flex">
                      <h3 style="font-weight: 400; margin-right: 6px">
                        VIEWING AS:
                      </h3>
                      <div>
                        <span
                          style="overflow: hidden; text-overflow: ellipsis"
                          class="wt_lvl_tag"
                          ><i
                            data-v-3a93b0e5=""
                            class="material-icons align-middle"
                            >account_balance_wallet</i
                          >{{ viewingAs.role }}</span
                        >
                      </div>
                    </div>
                    <div
                      @click="cancelViewing"
                      class="view-as-pannelclose-wrapper"
                    >
                      <div class="view-as-pannelclose">
                        <i class="material-icons-outlined align-middle"
                          >close</i
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex">
                    <!--                    <div class="aside-personal-avatar">-->
                    <div class="avatar" style="margin: 0">
                      <span v-if="!viewingAs.photoURL">{{
                        (viewingAs.name ? viewingAs.name : viewingAs.email)
                          | getFirstLetter
                      }}</span>
                      <img v-else :src="viewingAs.photoURL" alt />
                    </div>
                    <!--                      <div class="aside-personal-avatar-container">-->
                    <!--                    <span v-if="!viewingAs.photoURL" style="width:30px;">{{-->
                    <!--                        (viewingAs.name ? viewingAs.name : viewingAs.email) | getFirstLetter-->
                    <!--                      }}</span>-->
                    <!--                        <img v-else :src="viewingAs.photoURL" alt />-->
                    <!--&lt;!&ndash;                        <div&ndash;&gt;-->
                    <!--&lt;!&ndash;                            class="avatar-change-btn avatar-sm"&ndash;&gt;-->
                    <!--&lt;!&ndash;                            @click="openAvatarCrop"&ndash;&gt;-->
                    <!--&lt;!&ndash;                        >&ndash;&gt;-->
                    <!--&lt;!&ndash;                          <i class="material-icons align-middle">photo_camera</i>&ndash;&gt;-->
                    <!--&lt;!&ndash;                        </div>&ndash;&gt;-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <p
                      style="
                        line-height: 32px;
                        margin-left: 10px;
                        color: #1c1c1c;
                        font-size: 16px;
                      "
                    >
                      {{ viewingAs.email }}
                    </p>
                  </div>
                  <!--                  <h3>{{ viewingAs.role }}</h3>-->
                </div>
              </div>
              <ul class="main-menu" v-if="user.roles.admin && !viewingAs">
                <li class="main-menu-title">{{ $t("aside.admin.title") }}</li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{ path: '/home/admin/overview_admin', query: {} }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.admin.overview_icon")
                    }}</i>
                    {{ $t("aside.admin.overview") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{ path: '/home/admin/project_admin', query: {} }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.admin.project_admin_icon")
                    }}</i>
                    {{ $t("aside.admin.project_admin") }}
                  </router-link>
                </li>
                <li>
                  <!--                <a href="javascript:;" @click="consultant_admin_show = !consultant_admin_show">-->
                  <router-link
                    :to="{ path: '/home/admin/consultant_admin', query: {} }"
                    @click.native="
                      consultant_admin_show = !consultant_admin_show;
                      closeEditPannelTitle();
                    "
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.admin.consultant_admin_icon")
                    }}</i>
                    {{ $t("aside.admin.consultant_admin") }}
                    <i class="material-icons align-middle main-menu-dropdown"
                      >arrow_drop_down</i
                    >
                  </router-link>
                  <!--                </a>-->
                  <ul v-show="consultant_admin_show">
                    <li>
                      <router-link
                        @click.native="closeEditPannelTitle()"
                        :to="{
                          path: '/home/admin/admin_active_techs',
                          query: {},
                        }"
                      >
                        <i class="material-icons align-middle">{{
                          $t("aside.admin.active_techs_icon")
                        }}</i>
                        {{ $t("aside.admin.active_techs") }}
                      </router-link>
                    </li>
                    <!-- <li>
                      <router-link
                        @click.native="closeEditPannelTitle()"
                        :to="{
                          path: '/home/admin/admin_available_techs',
                          query: {},
                        }"
                      >
                        <i class="material-icons align-middle">{{
                          $t("aside.admin.available_techs_icon")
                        }}</i>
                        {{ $t("aside.admin.available_techs") }}
                      </router-link>
                    </li> -->
                    <li>
                      <router-link
                        @click.native="closeEditPannelTitle()"
                        :to="{ path: '/home/admin/payroll', query: {} }"
                      >
                        <i class="material-icons align-middle">{{
                          $t("aside.admin.payroll_icon")
                        }}</i>
                        {{ $t("aside.admin.payroll") }}
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        @click.native="closeEditPannelTitle()"
                        :to="{ path: '/home/admin/map', query: {} }"
                      >
                        <i class="material-icons align-middle">{{
                          $t("aside.admin.map_icon")
                        }}</i>
                        {{ $t("aside.admin.map") }}
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{ path: '/home/admin/company_admin', query: {} }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.admin.company_admin_icon")
                    }}</i>
                    {{ $t("aside.admin.company_admin") }}
                  </router-link>
                </li>

                <li>
                  <!--                <a href="javascript:;" @click="setting_admin_show = !setting_admin_show">-->
                  <router-link
                    :to="{ path: '/home/admin/setting_admin', query: {} }"
                    @click.native="
                      setting_admin_show = !setting_admin_show;
                      closeEditPannelTitle();
                    "
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.admin.setting_admin_icon")
                    }}</i>
                    {{ $t("aside.admin.setting_admin") }}
                    <i class="material-icons align-middle main-menu-dropdown"
                      >arrow_drop_down</i
                    >
                  </router-link>
                  <!--                </a>-->
                  <ul v-show="setting_admin_show">
                    <li>
                      <router-link
                        @click.native="closeEditPannelTitle()"
                        :to="{ path: '/home/admin/role_admin', query: {} }"
                      >
                        <i class="material-icons align-middle">{{
                          $t("aside.admin.role_admin_icon")
                        }}</i>
                        {{ $t("aside.admin.role_admin") }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul
                class="main-menu"
                v-if="
                  (user.client && !viewingAs) ||
                  (viewingAs && viewingAs.role == 'client')
                "
              >
                <li class="main-menu-title">
                  {{ $t("aside.client.title")
                  }}{{
                    viewingAs
                      ? viewingAs.name
                        ? " (" + viewingAs.name + ")"
                        : ""
                      : user.client.name
                      ? " (" + user.client.name + ")"
                      : ""
                  }}
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/client/client_available_projects',
                      query: { id: viewingAs ? viewingAs.id : user.client.id },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.client.available_projects_icon")
                    }}</i>
                    {{ $t("aside.client.available_projects") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/client/client_dashboard',
                      query: { id: viewingAs ? viewingAs.id : user.client.id },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.client.dashboard_icon")
                    }}</i>
                    {{ $t("aside.client.dashboard") }}
                  </router-link>
                </li>
                <!-- <li>
                  <router-link
                    :to="{
                      path: '/home/client/client_information',
                      query: { id: viewingAs ? viewingAs.id : user.client.id },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.client.information_icon")
                    }}</i>
                    {{ $t("aside.client.information") }}
                  </router-link>
                </li> -->
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/client/client_payment',
                      query: { id: viewingAs ? viewingAs.id : user.client.id },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.client.payment_icon")
                    }}</i>
                    {{ $t("aside.client.payment") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/client/client_document',
                      query: { id: viewingAs ? viewingAs.id : user.client.id },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.client.document_icon")
                    }}</i>
                    {{ $t("aside.client.document") }}
                  </router-link>
                </li>
              </ul>
              <ul
                class="main-menu"
                v-if="
                  (user.roles.consultant &&
                    user.consultant &&
                    user.consultant.isActive &&
                    !viewingAs) ||
                  (viewingAs && viewingAs.role == 'consultant')
                "
              >
                <li class="main-menu-title">
                  {{ $t("aside.consultant.title")
                  }}{{
                    viewingAs
                      ? viewingAs.name
                        ? " (" + viewingAs.name + ")"
                        : ""
                      : user.consultant.name
                      ? " (" + user.consultant.name + ")"
                      : ""
                  }}
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/consultant/consultant_available_projects',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.consultant.available_projects_icon")
                    }}</i>
                    {{ $t("aside.consultant.available_projects") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/consultant/consultant_dashboard',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.consultant.dashboard_icon")
                    }}</i>
                    {{ $t("aside.consultant.dashboard") }}
                  </router-link>
                </li>
                <li v-if="user.roles.admin">
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/consultant/consultant_resume',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons-outlined align-middle">{{
                      $t("aside.consultant.resume_icon")
                    }}</i>
                    {{ $t("aside.consultant.resume") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/consultant/consultant_payment',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.consultant.payment_icon")
                    }}</i>
                    {{ $t("aside.consultant.payment") }}
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/consultant/consultant_document',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.consultant.document_icon")
                    }}</i>
                    {{ $t("aside.consultant.document") }}
                  </router-link>
                </li>
                <li v-if="user.roles.admin && viewingAs">
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{
                      path: '/home/admin/consultant_review',
                      query: {
                        id: viewingAs ? viewingAs.id : user.consultant.id,
                      },
                    }"
                  >
                    <i class="material-icons-outlined align-middle">{{
                      $t("aside.consultant.review_icon")
                    }}</i>
                    {{ $t("aside.consultant.review") }}
                  </router-link>
                </li>
              </ul>
              <ul class="main-menu main-bottom-menu">
                <li>
                  <router-link
                    @click.native="closeEditPannelTitle()"
                    :to="{ path: '/home/settings', query: {} }"
                  >
                    <i class="material-icons align-middle">{{
                      $t("aside.global.settings_icon")
                    }}</i>
                    {{ $t("aside.global.settings") }}
                  </router-link>
                </li>
                <li>
                  <a href="javascript:;" @click="logout">
                    <i class="material-icons align-middle">{{
                      $t("aside.global.logout_icon")
                    }}</i>
                    {{ $t("aside.global.logout") }}
                  </a>
                </li>
              </ul>
            </div>
          </aside>
        </transition>
        <router-view
          ref="child"
          @openEditPannelTitle="openEditPannelTitle"
          :editOpenTitle="editOpen"
        />
      </div>

      <image-cropper
        v-if="user"
        v-show="imagecropperShow"
        :email="imagecropperEmail"
        :consultantId="user.uid"
        :key="imagecropperKey"
        :width="300"
        :height="300"
        url="avatars/"
        lang-type="en"
        :lang-ext="$t('imageCropper')"
        @close="close"
        @crop-upload-success="cropSuccess"
        @crop-upload-fail="cropFail"
      />
    </div>
    <!--    <transition name="edit-pannel">-->
    <!--      <div class="edit-pannel">ssssssssssss</div>-->
    <!--    </transition>-->
  </div>
</template>

<script>
import { auth } from "@/vendor/firebase";
import { mapState } from "vuex";
import { db } from "@/vendor/firebase";
import {
  getOnlyDocDataQuery,
  addDoc,
  addDocIfNotExist,
  updateByFiled,
  getDoc,
} from "@/vendor/database";
import ImageCropper from "@/components/public/ImageCropper";
import { APPLICATION_STATUSES } from "@/constant/constant";

export default {
  data() {
    return {
      dropMenu: false,
      asideOpen: true,
      authUser: null,

      imagecropperKey: 0,
      image: "https://wpimg.wallstcn.com/577965b9-bb9e-4e02-9f0c-095b41417191",

      projectId: null,
      roleId: null,

      consultant_admin_show: false,
      setting_admin_show: false,
      editOpen: false,
      title: null,
    };
  },
  components: { ImageCropper },
  computed: {
    ...mapState([
      "imagecropperShow",
      "imagecropperEmail",
      "user",
      "sidebarOpened",
      "techSlackId",
      "techUserId",
      "techUserName",
      "clientChannelId",
      "clientUserName",
      "clientUserAccount",
      "companyId",
      "viewingAs",
    ]),
  },
  watch: {
    $route() {
      this.updateViewAs();
    },
  },
  beforeMount() {
    this.projectId = this.$route.query.project_id;
    this.roleId = this.$route.query.role_id;
  },
  mounted: function () {
    this.globalClick(this.gClick);
    auth.onAuthStateChanged((user) => {
      if (this.authUser) return;
      this.authUser = user;
      this.roles = {};
      const allRoles = ["admin", "consultant", "client"];
      if (auth.currentUser) {
        auth.currentUser.getIdTokenResult().then(async (idTokenResult) => {
          for (const i in allRoles) {
            if (idTokenResult.claims[allRoles[i]]) {
              this.roles[allRoles[i]] = true;
            }
          }
          let usr = {
            uid: user.uid,
            displayName: user.displayName,
            email: user.email,
            photoURL: user.photoURL,
            roles: this.roles,
          };
          if (this.roles.consultant && idTokenResult.claims.consultant_id) {
            const consultantResult = await getDoc(
              "consultants",
              idTokenResult.claims.consultant_id
            );
            if (consultantResult.ok) {
              usr.consultant = {
                id: consultantResult.data.id,
                name: consultantResult.data.data.name,
                applicationStatus:
                  consultantResult.data.data.application_status,
                isActive: consultantResult.data.data.is_active ? true : false,
              };
              if (user.photoURL) {
                db.collection("consultants")
                  .doc(consultantResult.data.id)
                  .update({
                    photo_url: user.photoURL,
                  });
              }
            }
          }
          if (this.roles.client) {
            const clientResult = await this.getCompanyInfo(
              user.email,
              idTokenResult.claims.company
            );
            if (clientResult.ok) {
              usr.client = {
                id: clientResult.data.id,
                name: clientResult.data.data.name,
              };
            }
            if (user.photoURL) {
              updateByFiled("clients", "email", user.email, {
                photo_url: user.photoURL,
              });
            }
          }
          this.updateViewAs();
          this.$store.commit("setUser", usr);
          if (this.$router.currentRoute.path == "/") {
            if (this.roles.admin) {
              this.$router
                .push("/home/admin/consultant_admin")
                .catch((err) => {});
            } else if (this.roles.client) {
              if (usr.client && usr.client.id) {
                this.$router
                  .push(
                    "/home/client/client_available_projects?id=" + usr.client.id
                  )
                  .catch((err) => {});
              } else {
                this.$router.push("/home/no_account").catch((err) => {});
              }
            } else if (this.roles.consultant) {
              if (usr.consultant.isActive) {
                if (usr.consultant.id) {
                  this.$router
                    .push({
                      path: "/home/consultant/consultant_available_projects",
                      query:
                        this.projectId && this.roleId
                          ? {
                              project_id: this.projectId,
                              role_id: this.roleId,
                              id: usr.consultant.id,
                            }
                          : { id: usr.consultant.id },
                    })
                    .catch((err) => {});
                } else {
                  this.$router.push("/home/no_account").catch((err) => {});
                }
              } else {
                if (usr.consultant.applicationStatus) {
                  this.toApplicationStatuspage(
                    usr.consultant.applicationStatus
                  );
                } else {
                  this.$router
                    .push(
                      "/home/consultant/consultant_processing" +
                        usr.consultant.applicationStatus
                    )
                    .catch((err) => {});
                }
              }
            } else {
              this.$router.push("/home/no_permission").catch((err) => {});
            }
          }
          if (
            !usr.admin &&
            !usr.client &&
            usr.consultant &&
            !usr.consultant.isActive
          ) {
            if (usr.consultant.applicationStatus) {
              this.toApplicationStatuspage(usr.consultant.applicationStatus);
            } else {
              this.$router.push("/home/no_permission").catch((err) => {});
            }
          }
        });
      }
    });
  },
  methods: {
    openEditPannelTitle: function (event) {
      this.editOpen = event.editOpen;
      this.title = event.title;
    },
    closeEditPannelTitle: function () {
      this.editOpen = false;
    },
    async updateViewAs() {
      if (this.roles.admin && !this.viewingAs) {
        const consultant_view_as_paths = [
          "/home/consultant/consultant_dashboard",
          "/home/consultant/consultant_resume",
          "/home/consultant/consultant_payment",
          "/home/consultant/consultant_document",
          "/home/admin/consultant_review",
        ];
        if (consultant_view_as_paths.includes(this.$route.path)) {
          const { id: queryId } = this.$route.query;
          const consultant_result = await getDoc("consultants", queryId);
          if (consultant_result.ok) {
            const data = consultant_result.data;
            if (data.data.email !== this.authUser.email) {
              this.$store.commit("setTechUserId", data.id);
              this.$store.commit("setTechUserName", data.data.name);
              this.$store.commit("setViewingAs", {
                role: "consultant",
                email: data.data.email,
                name: data.data.name,
                slackId: data.data.slackId,
                id: data.id,
                photoURL: data.data.photoURL,
              });
            }
          }
        }
      }
    },
    openAvatarCrop() {
      this.$store.commit("setImagecropperEmail", this.user.email);
      this.$store.commit("setImagecropperShow", true);
      this.dropMenu = false;
    },
    cropFail(err) {
      this.$toasted.global.toast_error({ message: err });
    },
    cropSuccess(resData) {
      this.$store.commit("setImagecropperShow", false);
      this.imagecropperKey = this.imagecropperKey + 1;
      // this.image = resData.files.avatar
    },
    close() {
      this.$store.commit("setImagecropperShow", false);
    },
    logout: function () {
      auth.signOut().then(() => {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push("/login").catch((err) => {});
        });
      });
    },
    goSettings: function (e) {
      this.$router.push("/home/settings").catch((err) => {});
      this.dropMenu = false;
    },
    toggleMenu: function () {
      this.dropMenu = !this.dropMenu;
    },
    gClick(event) {
      this.$EventBus.$emit("globalClick", event);
      this.hideAll(event);
    },
    hideAll(event) {
      this.$nextTick(() => {
        if (
          this.$refs.dropmenu &&
          !(
            this.$refs.dropmenu.contains(event.target) ||
            this.$refs.dropbutton.contains(event.target) ||
            this.$refs.dropbuttonarrow.contains(event.target)
          )
        ) {
          this.dropMenu = false;
        }
      });
    },
    asideClick: function () {
      this.$store.commit("toggleSidebar");
    },
    cancelViewing: function () {
      const path = this.viewingAs.path;
      if (path) {
        this.$router.push(path).catch((err) => {});
      } else {
        this.$router.push("/home/admin/consultant_admin").catch((err) => {});
      }
      this.$store.commit("setViewingAs", null);
    },
    getCompanyInfo: async function (email, company) {
      const trimEmail = (email || "").trim();
      if (company) {
        const companyResult = await getDoc("companies", company);
        if (companyResult.ok) {
          return companyResult;
        }
      }
      const emailResult = await getOnlyDocDataQuery(
        "companies",
        "email",
        trimEmail
      );
      if (emailResult.ok) {
        return emailResult;
      }
      const billingEmailResult = await getOnlyDocDataQuery(
        "companies",
        "billing_email",
        trimEmail
      );
      if (billingEmailResult.ok) {
        return billingEmailResult;
      }
      const clientResult = await getOnlyDocDataQuery(
        "clients",
        "email",
        trimEmail
      );
      if (clientResult.ok) {
        const clientCompany = clientResult.data.data.company;
        const companyResult = await getDoc("companies", clientCompany);
        return companyResult;
      }
      return { ok: false };
    },
    toApplicationStatuspage: function (applicationStatus) {
      if (APPLICATION_STATUSES.indexOf(applicationStatus) >= 0) {
        this.$router
          .push("/home/consultant/consultant_" + applicationStatus)
          .catch((err) => {});
      } else {
        this.$router
          .push("/home/consultant/consultant_quiz?name=" + applicationStatus)
          .catch((err) => {});
      }
    },
  },
};
</script>

<style scoped>
.view-as-pannelclose-wrapper {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 8px;
  color: #909090;
  display: block;
  cursor: pointer;
  background-color: #fff;
}
.view-as-pannelclose-wrapper:hover {
  border-color: #e13914;
  color: #e13914;
}
.view-as-pannelclose {
  font-size: 12px;
  line-height: 12px;
}
</style>
